import Global from"./Global";
import Util from "../Service/util";
import Service from "../Service/http";
import { toast } from "react-toastify";
import { useState } from "react";
import { MdRefresh } from "react-icons/md";

function LeaderBoardPage(){
    let service = new Service();
    let util = new Util();
    let admin = util.isAdmin();
    let [loading, setLoading] = useState(false);
    const HandleSubmit = async () => {
        if(admin){
            setLoading(true);
            toast.success("Leaderboard has started regenerating, please wait for few minutes")
            service.get("api/admin/leaderboard/regenerate")
            .then((res)=>{
                if(res.retry === true){
                    toast.warn(res.message);
                }
                else{
                    toast.success(res.message);
                }
                setLoading(false);
            })
            .catch((err)=>{
                toast.error("Error occured in regenerating leaderboard")
                console.log(err);
                setLoading(false);
            })
        }
    }

    return (
        <div>
            <h3 className="text-primary mt-3 text-center font-weight-bold" >  Global Leaderboard </h3> 
            <div className="container-fluid d-flex justify-content-end">
            {util.isAdmin() && <button 
            className="custom-button"
            disabled={loading}
            onClick={HandleSubmit}><MdRefresh color="black" size={30}/></button>
            }
            </div>
        <Global/>
        </div>
    )
}

export default LeaderBoardPage;
